export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Длина`, `66`, `70`, `72`, `74`, `74`, `76`, `78`],
  [`Ширина`, `52`, `54`, `56`, `58`, `60`, `62`, `64`]
];
